import { FunctionComponent, useEffect } from 'react';

interface IOnSubmitValidationError {
  submitCount: number;
  isSubmitting: boolean;
  isValid: boolean;
  callback: () => void;
}

const OnSubmitValidationError: FunctionComponent<IOnSubmitValidationError> = props => {
  const { callback, submitCount, isSubmitting, isValid } = props;

  useEffect(() => {
    if (submitCount > 0 && !isSubmitting && !isValid) {
      callback();
    }
  }, [submitCount, isSubmitting]);

  return null;
};

export default OnSubmitValidationError;
